(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .controller('ContractTypeDialogController', ContractTypeDialogController);

    ContractTypeDialogController.$inject = ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'ContractType'];

    function ContractTypeDialogController ($scope, $stateParams, $uibModalInstance, entity, ContractType) {
        var vm = this;
        vm.contractType = entity;
        vm.load = function(id) {
            ContractType.get({id : id}, function(result) {
                vm.contractType = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('wamasysApp:contractTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.contractType.id !== null) {
                ContractType.update(vm.contractType, onSaveSuccess, onSaveError);
            } else {
                ContractType.save(vm.contractType, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
